import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

// Admin screens: a non-expired token from /auth/adminLogin (staff = usertype 3, super admin = usertype 4).
// UX only: the API must still check the token and role on every request.
@Injectable()
export class AdminAuthGuard implements CanActivate {
    constructor(private authService: AuthenticationService, private router: Router) { }

    canActivate(): boolean {
        const user = this.authService.getActiveSession();
        if (user && user.userDetail && ['3', '4'].indexOf(String(user.userDetail.usertype)) !== -1) {
            return true;
        }
        this.authService.clearSession();
        this.router.navigate(['login']);
        return false;
    }
}

// Partner screens: a non-expired token from /auth/partnerLogin (its userDetail carries partnerId).
@Injectable()
export class PartnerAuthGuard implements CanActivate {
    constructor(private authService: AuthenticationService, private router: Router) { }

    canActivate(): boolean {
        const user = this.authService.getActiveSession();
        if (user && user.userDetail && user.userDetail.partnerId) {
            return true;
        }
        this.authService.clearSession();
        this.router.navigate(['partnerLogin']);
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.guard.ts